var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-container" },
    [
      _c("div", { staticClass: "detail-header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", [
                  _vm._v(
                    _vm._s(_vm.$t("fixDutyFine.penaltyStatementBreadcrumb")) +
                      " "
                  ),
                ]),
              ],
              1
            ),
            _c("h2", { staticClass: "page-title" }, [
              _vm._v(
                _vm._s(_vm.routeInfo.type) +
                  " - " +
                  _vm._s(_vm.$t("fixDutyFine.waybillDetail"))
              ),
            ]),
            _c("p", { staticClass: "sub-title" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.routeInfo.reconciliationPeriod) +
                  " / " +
                  _vm._s(_vm.routeInfo.regionName) +
                  " / " +
                  _vm._s(_vm.routeInfo.type) +
                  " "
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleBack } },
              [_vm._v(_vm._s(_vm.$t("fixDutyFine.backToSummary")) + " ")]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.exportData },
              },
              [_vm._v(_vm._s(_vm.$t("fixDutyFine.exportDetail")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "status-tabs" },
        _vm._l(_vm.statusTabs, function (tab, index) {
          return _c(
            "div",
            {
              key: index,
              class: [
                "tab-item",
                { active: _vm.query.statusList === tab.value },
              ],
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(tab.value)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(tab.label) + " "),
              _c("span", { class: ["count", tab.colorClass] }, [
                _vm._v(_vm._s(_vm.formatNumber(tab.count))),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "filter-area" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, size: "small" } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      placeholder: _vm.$t("fixDutyFine.searchWaybill"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.query.waybillNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "waybillNumber", $$v)
                      },
                      expression: "query.waybillNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: {
                        placeholder: _vm.$t("fixDutyFine.allPenaltyTypes"),
                        clearable: "",
                        "collapse-tags": "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.query.responsibilityTypeList,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "responsibilityTypeList", $$v)
                        },
                        expression: "query.responsibilityTypeList",
                      },
                    },
                    _vm._l(_vm.responsibilityTypeList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: {
                        placeholder: _vm.$t("fixDutyFine.allRegions"),
                        clearable: "",
                        "collapse-tags": "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.query.regionId,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "regionId", $$v)
                        },
                        expression: "query.regionId",
                      },
                    },
                    _vm._l(_vm.regionsList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: _vm.getRegionName(item),
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: {
                        placeholder: _vm.$t("fixDutyFine.allProcessStatus"),
                      },
                      model: {
                        value: _vm.query.statusList,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "statusList", $$v)
                        },
                        expression: "query.statusList",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-search", type: "primary" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v(_vm._s(_vm.$t("fixDutyFine.query")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.resetQuery },
                    },
                    [_vm._v(_vm._s(_vm.$t("fixDutyFine.reset")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "batch-actions" },
            [
              _c("span", { staticClass: "hint-text" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("fixDutyFine.selectedHint", {
                      count: _vm.selectedRows.length,
                    })
                  )
                ),
              ]),
              _c(
                "el-button",
                {
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.exportData },
                },
                [_vm._v(_vm._s(_vm.$t("fixDutyFine.export")))]
              ),
              _vm.hasPermit("btn:DeductionConfirmationForm:batchProcess")
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleBatchProcess },
                    },
                    [_vm._v(_vm._s(_vm.$t("fixDutyFine.batchProcess")) + " ")]
                  )
                : _vm._e(),
              _vm.hasPermit(
                "btn:DeductionConfirmationForm:batchFinalDetermination"
              )
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleBatchFinalDetermination },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("fixDutyFine.batchFinalDetermination")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", type: "selection", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("base.billingMonth"),
              align: "center",
              prop: "reconciliationPeriod",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.waybillNumber"),
              align: "center",
              prop: "waybillNumber",
              width: "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "bold-waybill clickable-waybill",
                        on: {
                          click: function ($event) {
                            return _vm.handleAction(scope.row, "view")
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.waybillNumber))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.region"),
              align: "center",
              prop: "regionName",
              width: "90",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatRegionName(scope.row.regionName)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.site"),
              align: "center",
              prop: "siteName",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.latestTrackContent"),
              align: "left",
              prop: "latestTrackContent",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.latestTrackTime"),
              align: "center",
              prop: "latestTrackTime",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.penaltyType"),
              align: "center",
              prop: "responsibilityTypeName",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.DefiniteTime"),
              align: "center",
              prop: "responsibilityTime",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.penaltyAmount"),
              align: "center",
              prop: "totalPenaltyAmount",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm.formatCurrency(scope.row.totalPenaltyAmount))
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.processStatus"),
              align: "center",
              prop: "statusName",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "status-pill",
                        class: _vm.getStatusClass(scope.row.status),
                      },
                      [_vm._v(" " + _vm._s(scope.row.statusName) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.appealReason"),
              align: "left",
              prop: "appealReason",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.finalReviewOpinion"),
              align: "left",
              prop: "finalReviewOpinion",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.operation"),
              align: "center",
              fixed: "right",
              width: "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 1 &&
                    _vm.hasPermit("btn:DeductionConfirmationForm:process")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAction(scope.row, "process")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("fixDutyFine.process")) + " ")]
                        )
                      : _vm._e(),
                    scope.row.status === 3 &&
                    _vm.hasPermit(
                      "btn:DeductionConfirmationForm:finalDetermination"
                    )
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAction(scope.row, "final")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("fixDutyFine.finalDetermination")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleAction(scope.row, "view")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("fixDutyFine.view")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("div", { staticClass: "pagination-left" }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.paginationTip"))),
          ]),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.query.page,
              "page-size": _vm.query.size,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.query, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.query, "page", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.query, "size", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.query, "size", $event)
              },
              "current-change": _vm.getCurrentTableData,
              "size-change": _vm.getSizeTableData,
            },
          }),
        ],
        1
      ),
      _c("recordDrawer", { ref: "drawer" }),
      _c("process-penalty-dialog", {
        ref: "processDialog",
        on: { "submit-success": _vm.handleProcessSuccess },
      }),
      _c("final-determination-dialog", {
        ref: "finalDialog",
        on: { "submit-success": _vm.handleFinalSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }